<template>
  <el-tooltip :content="$slots.default" :disabled="tooltipShow" placement="top-start">
    <span ref="content" @mouseover="isShowTooltip">
      <slot></slot>
    </span>
  </el-tooltip>
</template>

<script>
export default {
  name: 'OverTooltip',
  data () {
    return {
      tooltipShow: true
    }
  },
  methods: {
    isShowTooltip () {
      const bool = this.$refs.content.offsetWidth <= this.$refs.content.parentNode.offsetWidth
      this.tooltipShow = bool
    }
  }
}
</script>

<style scoped>

</style>

